const config = {
	appDomain: 'https://betteroff-staging.kellypartners.com',
	apiDomain: 'https://api-staging.kellypartners.com/',
	blobStorageRootUrl: 'https://kpclientsstaging.blob.core.windows.net/',
	iPracticeRootUrl: '',
	environment: 'bostaging',
	title: 'BetterOffStaging',
	currentCulture: 'en-AU',
	stripePublishableKey:
		'pk_test_51NLK97ItboXz9npVH6G4nuUnjNnr3wwPGa2VjksWggTGG9zV4EZsjYfHeE280Wdlwh02yV1uLtvkZdKxmklpGV4R0040rS8GL9',
	appSupportEmail: 'AppSupport@kellypartners.com.au',
	appName: 'BetterOff',
	appVersion: '1.5.2',
	autoLogoutTimeoutInMs: 1800000,
	streamApiKey: 'q5ha77bndy3b'
};

export type Config = typeof config;

export default config;
